import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-screen-container',
    templateUrl: './screen-container.component.html',
    styleUrls: ['./screen-container.component.scss'],
    standalone: false
})
export class ScreenContainerComponent implements OnInit {
  @Input() margin: boolean = true;
  
  public constructor() {}

  public ngOnInit(): void {}
}
